class YCSelectElement extends HTMLElement {
  constructor(selectElement) {
    super();
    this.selectElement = selectElement;
    this.init();
  }

  init() {
    try {
      this.renderCustomSelect();
      this.addEventListeners();
      this.removeSelected();
      this.selectElement.style.display = "none"; // Hide original select
    } catch (error) {
      console.error("Error initializing YCSelectElement:", error);
    }
  }

  renderCustomSelect() {
    // Create custom select elements

    if (!this.selectElement) {
      return;
    }
    //console.log("this.selectElement", this.selectElement.options.length);
    if (this.selectElement.options.length === 0) {
      this.classList.add("empty");
      return;
    } else {
      this.classList.remove("empty");
    }

    // remove any existing custom select
    if (this.querySelector(".yc-custom-select")) {
      this.querySelector(".yc-custom-select").remove();
    }

    this.customSelect = document.createElement("div");
    this.customSelect.classList.add("yc-custom-select");
    this.customSelect.innerHTML = `
      <div class="yc-select-display"><span class="yc-select-label">${
        this.selectElement.options[this.selectElement.selectedIndex].text
      }</span><span class="yc-select-carret"><svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.31 5.63">
  <g id="Layer_1-2" data-name="Layer_1">
    <path fill="currentColor" d="M10.18.8l-4.69,4.69s-.1.08-.15.1c-.06.02-.12.04-.18.04s-.12-.01-.18-.04c-.06-.02-.11-.06-.15-.1L.14.8c-.09-.09-.14-.21-.14-.33S.05.23.14.14c.09-.09.21-.14.33-.14s.24.05.33.14l4.36,4.36L9.51.14s.1-.08.15-.1c.06-.02.12-.04.18-.04s.12.01.18.04c.06.02.11.06.15.1.04.04.08.1.1.15.02.06.04.12.04.18s-.01.12-.04.18c-.02.06-.06.11-.1.15Z"></path>
  </g>
</svg></span></div>
      <ul class="yc-select-options">
        ${Array.from(this.selectElement.options)
          .map(
            (option) =>
              `<li data-value="${option.value}" tabindex="${option.tabIndex}">${option.text}</li>`
          )
          .join("")}
      </ul>
    `;
    //this.selectElement.style.display = "none"; // Hide original select
    this.appendChild(this.customSelect);
  }

  updateCustomSelect() {
    this.renderCustomSelect();
    this.addEventListeners();
    this.removeSelected();
  }

  addEventListeners() {
    // Add event listeners for interactions

    if (this.customSelect) {
      this.customSelect
        .querySelector(".yc-select-display")
        .addEventListener("click", () => {
          this.customSelect.classList.toggle("open");

          // if the bottom of the page is less than 300px from the bottom of the view port open the select upwards
          const rect = this.customSelect.getBoundingClientRect();
          if (window.innerHeight < rect.bottom + 300) {
            this.customSelect.classList.add("open-upwards");
          } else {
            this.customSelect.classList.remove("open-upwards");
          }
        });
      this.customSelect
        .querySelectorAll(".yc-select-options li")
        .forEach((li) => {
          li.addEventListener("click", (e) => {
            const value = e.target.getAttribute("data-value");
            this.selectElement.value = value; // Update original select value

            this.removeSelected(); // Remove selected class from all options
            li.classList.add("selected");
            this.customSelect.querySelector(
              ".yc-select-display .yc-select-label"
            ).textContent = e.target.textContent; // Update display text
            this.customSelect.classList.remove("open"); // Close options
            this.customSelect.classList.remove("open-upwards"); // Remove upwards class

            this.dispatchEvent(new Event("change")); // Trigger change event
            this.selectElement.dispatchEvent(new Event("change"));
          });
        });
    } else {
      console.warn("No custom select element found to add event listeners to.");
    }

    // click outside to close the select
    document.addEventListener("click", (e) => {
      if (!this.customSelect.contains(e.target)) {
        this.customSelect.classList.remove("open");
        this.customSelect.classList.remove("open-upwards");
      }
    });

    // listen for external change to the element.
    this.selectElement.addEventListener("change", (e) => {
      console.log("external change", e);
      this.customSelect.querySelector(
        ".yc-select-display .yc-select-label"
      ).textContent = e.target.options[e.target.selectedIndex].text;
    });
    this.selectElement.addEventListener("selectionchange", (e) => {
      console.log("external selectionchange", e);
    });

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          this.updateCustomSelect();
        } else if (mutation.type === "characterData") {
        } else if (mutation.type === "attributes") {
        }
      }
    });
    observer.observe(this.selectElement, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  removeSelected() {
    // Remove selected class from all options
    if (!this.customSelect) {
      return;
    }
    this.customSelect
      .querySelectorAll(".yc-select-options li")
      .forEach((li) => {
        li.classList.remove("selected");
      });
  }
}

customElements.define("yc-custom-select", YCSelectElement);

document.addEventListener("DOMContentLoaded", () => {
  const selectWrapper = document.querySelectorAll(".yc-select-wrapper");
  selectWrapper.forEach((selectWrapper) => {
    const selectElement = selectWrapper.querySelector("select");
    const customSelect = new YCSelectElement(selectElement);
    selectWrapper.appendChild(customSelect);
  });
});
